import { z } from "zod";

export const formattedName = (errmsg?: string) =>
  z
    .string()
    .min(1, errmsg || "Value must have a minimum of 1 character")
    .transform((val) => val.charAt(0).toUpperCase() + val.slice(1));
